import React, { useState } from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiUserPlus } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { Label, MenuElement } from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import {
  getUserId,
  getUserPriceGroup,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import { useSelector } from 'react-redux'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import {
  isInPlanScope,
  isInPlanScopeRedirect,
  PlansScope,
  useLicensePlansScope,
} from '../index'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import { useMediaQuery, useTheme } from '@material-ui/core'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { getActiveLicense } from '../../../../../reducers/userAccount/selectors/license'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'

function sendMixPanel(userId) {
  return function() {
    Mixpanel.people.increment(userId, 'Employees Menu Item Opened', 1)
    Mixpanel.track('Employees List Menu Item Used', {})
  }
}

function Employees({
  size = 1,
  isSidebarOpen,
}: IWithSize & WithTranslation & any) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const userId = useSelector(getUserId)
  const activeLicense = useSelector(
    getActiveLicense,
  )

  const skipScope = activeLicense?.has_workers
  const userPriceGroup = useSelector(getUserPriceGroup)
  const planScope = useLicensePlansScope()
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [isModalOpened, setIsModalOpened] = useState(false)

  const handleLinkClick = event => {
    if (
      isMobile &&
      isInPlanScope(planScope, PlansScope.Employees, userPriceGroup) === true &&
      (!activeLicense?.has_workers)
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (!isMobile && (isInPlanScope(planScope, PlansScope.Employees, userPriceGroup) && !activeLicense?.has_workers )) {
      event.preventDefault()
      event.stopPropagation()
      setPopoverAnchor(event.currentTarget)
    }  else {
      sendMixPanel(userId)
    }
  }

  // const handlePopoverOpen = event => {
  //   event.preventDefault()
  //   event.stopPropagation()
  //   sendMixPanel(userId)
  //   setPopoverAnchor(event.currentTarget)
  // }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //   if (isSidebarOpen) {
  //
  //     setTimeout(() => {
  //       setPopoverAnchor(target)
  //     }, 50)
  //   }
  // }

  return (
    <>
      <MenuElement size={size} alignCenter={true}>
        <SmartLink
          size={size}
          disabled={
            (isInPlanScope(planScope, PlansScope.Employees, userPriceGroup) && !activeLicense?.has_workers )
          }
          to={isInPlanScopeRedirect(
            planScope,
            PlansScope.Employees,
            '/employees',
            userPriceGroup,
            skipScope,
          )}
          onClick={handleLinkClick}
        >
          <Flex full alignCenter={true} justifyBetween>
            <b>
              <FiUserPlus size={16 * size} />
            </b>
            <Label size={size} primary={true}>
              <Trans i18nKey={'BED_3607_staff'}>Pracownicy</Trans>
            </Label>
            {isSidebarOpen &&
              isInPlanScope(planScope, PlansScope.Employees, userPriceGroup) &&
              !skipScope && (
                <PopoveredIcon2
                  anchorEl={popoverAnchor}
                  // onOpen={handlePopoverOpen}
                  onClose={handlePopoverClose}
                />
              )}
          </Flex>
        </SmartLink>
      </MenuElement>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default Employees
